import { render, staticRenderFns } from "./PostGeneral.vue?vue&type=template&id=43b83f4d"
import script from "./PostGeneral.vue?vue&type=script&lang=js"
export * from "./PostGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports